import {
  Component,
  OnInit,
  forwardRef,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import {
  FormControl,
  FormGroupDirective,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { MatSelect, MatSelectChange } from "@angular/material/select";

@Component({
  selector: "app-select",
  templateUrl: "./select.component.html",
  styleUrls: ["./select.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SelectComponent),
    },
  ],
})
export class SelectComponent implements OnInit {
  @Input() controlName = "";
  @Input() label = "";
  @Input() optionTextField = "";
  @Input() optionValueField = "";
  @Input() options: any[] = [];
  @Input() disabled = false;
  @Output() selectionChange: EventEmitter<MatSelectChange> = new EventEmitter();
  @ViewChild("selectEl", { static: false }) selectEl!: MatSelect;
  @Input() id!: any;

  get formControl(): FormControl | null {
    const control = this.formGroupDirective.form.get(this.controlName);
    if (control) {
      return control as FormControl;
    }

    return null;
  }

  constructor(private formGroupDirective: FormGroupDirective) {}

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.selectEl.focus();
  }

  onChange(change: MatSelectChange): void {
    this.selectionChange.next(change);
  }
}
